import type { IssueCard } from '@tasks/contracts';

import type { Page } from '../lib/types';
import { apiRequest } from './client';

export type QuickSearchResult = Page<IssueCard>;

/** Быстрый поиск по ключу/заголовку (docs/05 §10). */
export function quickSearch(q: string, limit = 20, signal?: AbortSignal): Promise<QuickSearchResult> {
  return apiRequest<QuickSearchResult>('/search', { query: { q, limit }, signal });
}
